export default {
  data() {
    return {
      canUseWebPMixin: canUseWebP()
    }
  },
  methods: {
    isRouteNameMixin(name) {
      return this.$route.name === name || this.$route.name === name + '-double'
    },
    getRouteNameMixin() {
      const name = this.$route.name
      if (!name) return name

      return name.endsWith('-double') ? name.slice(0, -('-double'.length)) : name
    },
    createAltMixin(name, n, isVideo) {
      let nPrefix = isVideo ? this.$tGlobal('video') : this.$tGlobal('photo')
      let nStr = n ? ` - ${nPrefix} ${n}` : ''
      return `${name}${nStr} - ${this.$tGlobal('job search service abroad - jobian')}`
    },
    createTitleMixin(name, n, isVideo) {
      let nPrefix = isVideo ? this.$tGlobal('video') : this.$tGlobal('photo')
      let nStr = n ? ` - ${nPrefix} ${n}` : ''
      return `${name}${nStr}`
    }
  }
}

function canUseWebP() {
  const elem = document.createElement('canvas');

  if (elem.getContext && elem.getContext('2d')) {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
  }

  // very old browser like IE 8, canvas not supported
  return false;
}
